export enum DRAGGABLE_COMPONENT_TYPE {
    editorOutlineTitle = 'editor-outline-title',
    editorOutlineSection = 'editor-outline-section',
}
